<template>
	<div id="VideoPlayer" class="fullSize">

		<div id="VideoPlayer_innervid">

			<div id="VideoPlayer_close" v-on:click="close"></div>

			<video id="VideoPlayer_videobase" ref="videobase" v-bind:src="this.App.video.src" controls crossOrigin="anonymous" class="fullSize"
			v-if="!isExternal()" v-on:loadeddata="videoLoaded">
				Your browser does not support the video tag.
			</video>

			<iframe id="VideoPlayer_videoframe" ref="videoframe" class="fullSize" v-bind:src="this.App.video.src" width="500" height="281" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen
			v-if="isExternal()"></iframe>

		</div>
		
	</div>
</template>

<script>
export default {
	name: 'VideoPlayer',
	props: {
		App: Object
	},
	data : function() {
		return {
			
		}
	},
	mounted() {

		document.addEventListener('displayVideoPanel', () => {
			this.App.video.display = true;
			if(!this.isExternal()) {
				if(this.$refs.videobase != undefined) {
					this.$refs.videobase.load();
				}
				
			}
		})

	},
	created() {
	},
	methods : {

		videoLoaded() {
				if(this.App.video.display) // if still displaying the video
					this.$refs.videobase.play();
		},

		close() {
			this.App.video.display = false;
			this.App.video.src = '';
			document.dispatchEvent(this.App.events.hideVideoPanel)
		},

		isExternal() {
			return this.App.video.src.toLowerCase().endsWith('.mp4') ? false: true
		}

	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
